import React, { Component } from "react";
import QrCodeReader from "./QrCodeReader";
import { withRouter } from "react-router-dom";


class StewardVerifyIdentity extends Component {
  //--- ---

  render() {
    const { idLesson, lessonType } = this.props.match.params;

    return (
      <>
        <section className="stewardPage">
          <QrCodeReader idLesson={idLesson} lessonType={lessonType} />
        </section>
      </>
    );
  }
}

export default withRouter(StewardVerifyIdentity);
